import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../Context/AuthProvider";
import { getFacilityDetails, updateFacility } from "../API/FacilitySettingsApi";
import {
  Grid2,
  Card,
  Button,
  TextField,
  Tooltip,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Chip,
  Box,
} from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { PhotoCamera, Delete } from "@mui/icons-material";
import { useSnackbar } from "../Utility/UserMessageContext";
import MenuBar from "../common/MenuBar";
import "../common/styles/CommonStyles.css"; // Import your custom styles
import GenericTextField from "../common/GenericTextField";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import GenericDatePicker from "../common/GenericDatePicker";
import GenericDropDown from "../common/GenericDropDown";
import GenericFileUploader from "../common/GenericFileUploader";
import { PrescriptionTypes, UserRolesConstants } from "../Utility/Constants";
import { AvailablePrescriptionTypes } from "../Utility/Constants";
import { showLoadingImage } from "../Utility/Utility";

// Prescription types available (excluding notes and medical records)
// const PRESCRIPTION_TYPES = [
//   { value: "GeneralPrescription", label: "General Prescription" },
//   { value: "PhysiotherapyPrescription", label: "Physiotherapy Prescription" },
//   { value: "PathologyLabReport", label: "Pathology Lab Report" },
// ];

function FacilityBasicSettings() {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const [editMode, setEditMode] = useState(false);
  const [facilityToEdit, setFacilityToEdit] = useState();
  const [facilityName, setFacilityName] = useState();
  const [mobileNumber, setMobileNumber] = useState();
  const [emailId, setEmailId] = useState();
  const [addressLine1, setAddressLine1] = useState();
  const [addressLine2, setAddressLine2] = useState();
  const [addressPIN, setAddressPIN] = useState();
  const [addressState, setAddressState] = useState();
  const [addressCity, setAddressCity] = useState();
  const [logoBase64Url, setLogoBase64Url] = useState();
  const [loading, setloading] = useState(false);

  // Check if user is facility admin
  const isFacilityAdmin = auth?.auth?.roles?.includes(UserRolesConstants.FacilityAdmin) || false;

  // New state for prescription configuration
  const [selectedPrescriptionTypes, setSelectedPrescriptionTypes] = useState(
    []
  );
  const [prescriptionEditMode, setPrescriptionEditMode] = useState(false);
  useEffect(() => {
    const loadFacility = async () => {
      setloading(true);
      const result = await getFacilityDetails(auth);
      if (result?.isSuccess) {
        setFacilityToEdit(result?.data);
        setFacilityName(result?.data?.name);
        setEmailId(result?.data?.email);
        setMobileNumber(result?.data?.mobileNo);
        setAddressLine1(result?.data?.addressLine1);
        setAddressLine2(result?.data?.addressLine2);
        setAddressPIN(result?.data?.pin);
        setAddressState(result?.data?.state);
        setAddressCity(result?.data?.city);
        setLogoBase64Url(result?.data?.logo);

        // Load all types from licenseDetails
        const allowedPrescriptions =
          result?.data?.licenseDetails?.allowedPrescriptions;

        if (allowedPrescriptions && allowedPrescriptions.length > 0) {
          // ✅ Filter out null, undefined, empty values
          const filteredTypes = allowedPrescriptions.filter(
            (type) => type != null && type !== ""
          );
          setSelectedPrescriptionTypes(filteredTypes);
        } else {
          // Default values - ALL types
          const defaultTypes = AvailablePrescriptionTypes.map(
            (type) => type.value
          );
          setSelectedPrescriptionTypes(defaultTypes);
        }
      } else {
        console.log("Failed to fetch facility details:", result?.data);
      }
      setloading(false);
    };

    loadFacility();
  }, [auth, location?.state]);

  // Save facility details
  // Replace your saveFacilityDetails function with this fixed version:

const saveFacilityDetails = async (e) => {
  e.preventDefault();

  var form = document.getElementById("basicFacilityDetailsForm");

  if (form.checkValidity()) {
    // ✅ Include licenseDetails to preserve prescription configuration
    const facility = {
      name: facilityName,
      emailId: emailId,
      mobileNo: mobileNumber,
      isActive: true,
      logo: logoBase64Url,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      addressPIN: addressPIN,
      addressState: addressState,
      addressCity: addressCity,
      // ✅ IMPORTANT: Include existing license details
      licenseDetails: {
        allowedPrescriptions: selectedPrescriptionTypes.filter(
          (type) => type != null && type !== ""
        ),
      },
    };

    console.log("Updating facility:", facility); // Debugging
    setloading(true);
    const result = await updateFacility(auth?.auth, facility);

    console.log("Update Facility Response:", result); // Debugging

    if (result?.isSuccess) {
      // Update the local state with the new data
      setFacilityToEdit(result?.data);
      setFacilityName(result?.data?.name);
      setEmailId(result?.data?.email);
      setMobileNumber(result?.data?.mobileNo);
      setAddressLine1(result?.data?.addressLine1);
      setAddressLine2(result?.data?.addressLine2);
      setAddressPIN(result?.data?.pin);
      setAddressState(result?.data?.state);
      setAddressCity(result?.data?.city);
      setLogoBase64Url(result?.data?.logo);

      // ✅ Update prescription types from response
      const savedTypes = result?.data?.licenseDetails?.allowedPrescriptions;
      if (savedTypes && savedTypes.length > 0) {
        const cleanTypes = savedTypes.filter(
          (type) => type != null && type !== ""
        );
        setSelectedPrescriptionTypes(cleanTypes);
      }

      // Exit edit mode
      setEditMode(false);

      // Show success toast
      showSnackbar("Facility details updated successfully.", "success");
    } else {
      // Show error toast
      showSnackbar(
        "Failed to update facility details. Please try again.",
        "error"
      );
    }
    setloading(false);
  }
};

  // Save prescription configuration
  // const savePrescriptionConfiguration = async () => {
  //   try {
  //     const facility = {
  //       name: facilityName,
  //       emailId: emailId,
  //       mobileNo: mobileNumber,
  //       isActive: true,
  //       logo: logoBase64Url,
  //       addressLine1: addressLine1,
  //       addressLine2: addressLine2,
  //       addressPIN: addressPIN,
  //       addressState: addressState,
  //       addressCity: addressCity,
  //       licenseDetails: {
  //         allowedPrescriptions: selectedPrescriptionTypes,
  //       },
  //     };

  //     const result = await updateFacility(auth?.auth, facility);

  //     if (result?.isSuccess) {
  //       showSnackbar(
  //         "Prescription configuration saved successfully.",
  //         "success"
  //       );
  //       setPrescriptionEditMode(false);

  //       // Update local state with new data
  //       setFacilityToEdit(result?.data);
  //       setSelectedPrescriptionTypes(
  //         result?.data?.licenseDetails?.allowedPrescriptions ||
  //           selectedPrescriptionTypes
  //       );
  //     } else {
  //       showSnackbar(
  //         result?.message || "Failed to save prescription configuration.",
  //         "error"
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error saving prescription configuration:", error);
  //     showSnackbar("Failed to save prescription configuration.", "error");
  //   }
  // };

  const savePrescriptionConfiguration = async () => {
    try {
      // ✅ Filter out null values before saving
      const filteredPrescriptionTypes = selectedPrescriptionTypes.filter(
        (type) => type != null && type !== ""
      );

      const facility = {
        name: facilityName,
        emailId: emailId,
        mobileNo: mobileNumber,
        isActive: true,
        logo: logoBase64Url,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        addressPIN: addressPIN,
        addressState: addressState,
        addressCity: addressCity,
        licenseDetails: {
          allowedPrescriptions: filteredPrescriptionTypes, // ✅ Use filtered array
        },
      };
      setloading(true);
      const result = await updateFacility(auth?.auth, facility);

      if (result?.isSuccess) {
        showSnackbar(
          "Prescription configuration saved successfully.",
          "success"
        );
        setPrescriptionEditMode(false);

        setFacilityToEdit(result?.data);

        // ✅ Filter again when setting from response
        const savedTypes =
          result?.data?.licenseDetails?.allowedPrescriptions ||
          filteredPrescriptionTypes;
        const cleanTypes = savedTypes.filter(
          (type) => type != null && type !== ""
        );
        setSelectedPrescriptionTypes(cleanTypes);

        // Update auth context
        if (auth?.setAuth && auth?.auth) {
          const updatedAuth = {
            ...auth.auth,
            selectedFacility: {
              ...auth.auth.selectedFacility,
              licenseDetails: {
                ...(auth.auth.selectedFacility?.licenseDetails || {}),
                allowedPrescriptions: cleanTypes,
              },
            },
          };

          auth.setAuth(updatedAuth);
        }
      } else {
        showSnackbar(
          result?.message || "Failed to save prescription configuration.",
          "error"
        );
      }
      setloading(false);
    } catch (error) {
      console.error("Error saving prescription configuration:", error);
      showSnackbar("Failed to save prescription configuration.", "error");
    }
  };

  // Handle logo change
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoBase64Url(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle logo delete
  const handleLogoDelete = () => {
    setLogoBase64Url(null);
  };

  // Handle prescription type selection change
  const handlePrescriptionTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedPrescriptionTypes(
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <Grid2 container spacing={2} size={12} sx={{ alignContent: "center" }}>
      {/* Action Buttons */}
      <Grid2 container size={12}>
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(216, 214, 214, 0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1301,
            }}
          >
            {showLoadingImage()}
          </div>
        )}
        <Grid2 size={12}>
          <MenuBar
            showEdit={!editMode}
            onEdit={() => setEditMode(true)}
            showSave={editMode}
            onSave={() => {
              const form = document.getElementById("basicFacilityDetailsForm");
              if (form) form.requestSubmit(); // Triggers form submit properly
            }} // This will be handled by form submission
            showCancel={editMode}
            onCancel={() => setEditMode(false)}
            disabled={!isFacilityAdmin}
          />
        </Grid2>
      </Grid2>

      {/* Main Content */}
      <Grid2
        container
        spacing={2}
        size={12}
        sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
      >
        {/* Original Form Card */}
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}>
          <Card className="outerCard" variant="outlined" sx={{ marginLeft: 1 }}>
            {editMode ? (
              <form
                noValidate
                className="was-validated"
                onSubmit={saveFacilityDetails}
                id="basicFacilityDetailsForm"
              >
                <Grid2 container spacing={2} size={12} sx={{ padding: 1 }}>
                  <Grid2 item size={12}>
                    <GenericTextField
                      label="Name"
                      value={facilityName}
                      onChange={(e) => setFacilityName(e.target.value)}
                      required
                    />
                  </Grid2>

                  <GenericTextField
                    label="Address Line 1"
                    value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                    required
                  />
                  <Grid2 size={12}>
                    <GenericTextField
                      label="Address Line 2"
                      value={addressLine2}
                      onChange={(e) => setAddressLine2(e.target.value)}
                    />
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                    <GenericTextField
                      label="PIN"
                      value={addressPIN}
                      onChange={(e) => setAddressPIN(e.target.value)}
                      required
                    />
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                    <GenericTextField
                      label="State"
                      value={addressState}
                      onChange={(e) => setAddressState(e.target.value)}
                      required
                    />
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                    <GenericTextField
                      label="City"
                      value={addressCity}
                      onChange={(e) => setAddressCity(e.target.value)}
                      required
                    />
                  </Grid2>
                  <Grid2
                    item
                    size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                    backgroundColor="white"
                  >
                    <TextField
                      margin="dense"
                      size="small"
                      label="Email Id"
                      variant="outlined"
                      fullWidth
                      value={emailId}
                      onChange={(e) => setEmailId(e.target.value)}
                      required
                    />
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                    <GenericTextField
                      label="Mobile No."
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                      required
                    />
                  </Grid2>
                </Grid2>
              </form>
            ) : (
              <Grid2 container sx={{ padding: 2 }}>
                <Grid2
                  container
                  size={{ xs: 12, sm: 12, md: 12, lg: 3, xl: 3 }}
                >
                  <Grid2
                    container
                    size={12}
                    sx={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <img
                      src={logoBase64Url || "./hospital.png"}
                      alt="Facility Logo"
                      style={{ borderRadius: "50%" }}
                      height="100"
                      width="100"
                    />
                  </Grid2>
                </Grid2>
                <Grid2
                  container
                  size={{ xs: 12, sm: 12, md: 12, lg: 9, xl: 9 }}
                  sx={{ pl: 2 }}
                >
                  <Grid2 size={12}>
                    <Typography variant="h6" sx={{ mb: "5px" }}>
                      {facilityName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography variant="body2" color="text.secondary">
                      Address
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography variant="body2">
                      {addressLine1},&nbsp;{addressLine2}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography variant="body2">
                      {addressCity},&nbsp;{addressState},&nbsp;{addressPIN}
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ color: "grey" }}
                    >
                      Email
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography variant="body2">{emailId}</Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ color: "grey" }}
                    >
                      Mobile No.
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <Typography variant="body2">{mobileNumber}</Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
            )}
          </Card>
        </Grid2>

        {/* Photo Card - Only in Edit Mode */}
        {editMode && (
          <Grid2 size={{ xs: 8, sm: 8, md: 8, lg: 2, xl: 2 }}>
            <Card className="outerCard" variant="outlined">
              <Grid2
                container
                spacing={1}
                sx={{ padding: 1 }}
                direction="column"
                alignItems="center"
              >
                <Grid2>
                  <img
                    src={logoBase64Url || "./hospital.png"}
                    alt="Facility Logo"
                    width="120"
                    height="120"
                    style={{ borderRadius: "50%" }}
                  />
                </Grid2>
                <Grid2 container justifyContent="center" spacing={1}>
                  <Grid2>
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      id="logo-upload"
                      onChange={handleLogoChange}
                    />
                    <label htmlFor="logo-upload">
                      <IconButton component="span">
                        <PhotoCamera />
                      </IconButton>
                    </label>
                  </Grid2>
                  <Grid2>
                    <IconButton onClick={handleLogoDelete}>
                      <Delete />
                    </IconButton>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Card>
          </Grid2>
        )}

        {/* NEW: Prescription Configuration Card */}
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
          <Card className="outerCard" variant="outlined">
            <Grid2 container sx={{ padding: 2 }}>
              <Grid2 size={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h6">
                    Prescription Configuration
                  </Typography>
                  {!prescriptionEditMode && (
                    <Tooltip title="Edit Prescription Settings">
                      <IconButton
                        onClick={() => setPrescriptionEditMode(true)}
                        disabled={!isFacilityAdmin}
                      >
                        <EditOutlined />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Grid2>

              <Grid2 size={12}>
                {prescriptionEditMode ? (
                  <Box>
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                      <InputLabel id="prescription-types-label">
                        Available Document Types
                      </InputLabel>
                      <Select
                        labelId="prescription-types-label"
                        multiple
                        value={selectedPrescriptionTypes}
                        onChange={handlePrescriptionTypeChange}
                        input={
                          <OutlinedInput label="Available Document Types" />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => {
                              const item = AvailablePrescriptionTypes.find(
                                (type) => type.value === value
                              );
                              return (
                                <Chip
                                  key={value}
                                  label={item?.label || value}
                                  size="small"
                                />
                              );
                            })}
                          </Box>
                        )}
                      >
                        {AvailablePrescriptionTypes.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Box display="flex" gap={1} justifyContent="flex-end">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          setPrescriptionEditMode(false);
                          // Reset to original values if needed
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={savePrescriptionConfiguration}
                        disabled={selectedPrescriptionTypes.length === 0}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Current Available Prescription Types:
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                        mt: 1,
                      }}
                    >
                      {selectedPrescriptionTypes &&
                      selectedPrescriptionTypes.length > 0 ? (
                        selectedPrescriptionTypes.map((value) => {
                          const prescriptionType =
                            AvailablePrescriptionTypes.find(
                              (type) => type.value === value
                            );
                          return (
                            <Chip
                              key={value}
                              label={prescriptionType?.label || value}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          );
                        })
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No prescription types configured
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </Grid2>
            </Grid2>
          </Card>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default FacilityBasicSettings;
